module.exports = __webpack_public_path__ + "static/media/ruler-pencil.1784a145.svg";